import { render, staticRenderFns } from "./ArticleInfo.vue?vue&type=template&id=7f3ebeca&scoped=true"
import script from "./ArticleInfo.vue?vue&type=script&lang=ts"
export * from "./ArticleInfo.vue?vue&type=script&lang=ts"
import style0 from "./ArticleInfo.vue?vue&type=style&index=0&id=7f3ebeca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3ebeca",
  null
  
)

export default component.exports